import { ReactNode } from 'react'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { AiChatPanel } from './AiChatPanel'
import { AiChatPanelProvider } from '@/contexts/AiChatPanelContext'
import { useMe } from '@/features/auth/hooks/useAuth'

interface AppShellProps {
    children: ReactNode
}

export function AppShell({ children }: AppShellProps) {

    // Fetch complete user data including avatarUrl
    useMe()

    return (
        <AiChatPanelProvider>
            <div className="flex h-screen bg-background">
                <Sidebar />
                <div className="flex flex-1 flex-col overflow-hidden bg-card">
                    <Topbar />
                    <main className="flex-1 overflow-auto bg-background">
                        <div className="container mx-auto p-4">
                            {children}
                        </div>
                    </main>
                </div>
                <AiChatPanel />
            </div>
        </AiChatPanelProvider>
    )
}


